import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const TextInput = forwardRef((props, ref) => {
    return (
        <input
            className='w-full bg-surface-raised border-0 h-46 px-10 type-style-body rounded placeholder:text-grey-800/40'
            ref={ref}
            type='text'
            {...props} />
    );
});

TextInput.displayName = 'TextInput';

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

TextInput.propTypes = {};

export default TextInput;
